module.exports = __webpack_public_path__ + "static/media/cz.dcee4432.svg";